export default "__VITE_ASSET__BpHyvaoC__"